import apiSlice from "../../app/api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		register: builder.mutation({
			query: (credentials) => ({
				url: "/api/register",
				method: "POST",
				body: { ...credentials },
			}),
		}),
		login: builder.mutation({
			query: (credentials) => ({
				url: "/api/login",
				method: "POST",
				body: { ...credentials },
			}),
		}),
		logout: builder.mutation({
			query: () => ({
				url: "/api/logout",
				method: "POST",
			}),
		}),
		forgotPassword: builder.mutation({
			query: ({ email }) => ({
				url: "/api/forgot-password",
				method: "POST",
				body: { email },
			}),
		}),
		setPassword: builder.mutation({
			query: ({ token, data }) => ({
				url: `/api/reset-password/${token}`,
				method: "POST",
				body: { ...data },
			}),
		}),
		getSettingsJSON: builder.query({
			query: () => `/api/settings`,
			providesTags: [{ type: "AppSettings", id: "LIST" }],
		}),
		loginAsUser: builder.mutation({
			query: ({ userId }) => ({
				url: `/api/admin/login-as-user/${userId}`,
				method: "POST",
			}),
		}),
	}),
	overrideExisting: true,
});

export const {
	useGetSettingsJSONQuery,
	useRegisterMutation,
	useLoginMutation,
	useLogoutMutation,
	useForgotPasswordMutation,
	useSetPasswordMutation,
	useLoginAsUserMutation,
} = authApiSlice;
